import React, { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import Button from "../../../../components/Button/Button";
import { InputField1 } from "../../../../components/InputField1/InputField1";
import Typography from "../../../../components/Typography/Typography";
import { Container } from "../../../../theme/GlobalStyle";
import { FiDelete } from "react-icons/fi";
import { optionAtom } from "../../../../shared/manament";
import { useUpdateSms } from "../../../../hooks/useAccounting";
import { IdUser } from "../../../../services/apiConfig";
import { useParams } from "react-router-dom";
import { Spinner } from "reactstrap";

const InputComponentManagement = ({ options }) => {
  const [listOptions, setListOptions] = useRecoilState(optionAtom);
  const [select, setSelect] = useState(false);
  const { id: panel_id } = useParams();
  const convertOptions = (event, text, id) => {
    if (event.key === "Enter") {
      updateListOptions(text, id);
    }
  };

  const updateListOptions = (text, id) => {
    const findOption = listOptions.find((option) => option.meta === id);
    const newOption = {
      ...findOption,
      params: [...findOption.params, text],
    };
    setListOptions((prevState) => {
      const newList = prevState.map((option) =>
        option.meta === newOption.meta ? newOption : option
      );
      return newList;
    });
  };

  const handleDelete = (meta, param) => {
    const findListOption = listOptions.find((option) => option.meta === meta);
    const findParam = findListOption.params?.filter(
      (paramItem) => paramItem !== param
    );
    setListOptions((prevState) => {
      const newList = prevState.map((option) =>
        option.meta === findListOption.meta
          ? { ...findListOption, params: findParam }
          : option
      );
      return newList;
    });
  };

  const { mutateAsync: updateSmsPanel, isLoading: loadingUpdateSms } =
    useUpdateSms();
  const handleUpdate = async (id) => {
    setSelect(id);
    const findUpdateSmsList = listOptions.find((option) => option.meta === id);
    const formData = new FormData();
    formData.append("panel_id", panel_id);
    formData.append("meta", findUpdateSmsList.meta);
    formData.append("pattern", findUpdateSmsList.pattern);
    formData.append("IdUser", IdUser);
    for (let i = 0; i < findUpdateSmsList.params?.length; i++) {
      formData.append(`parameter[${i}]`, findUpdateSmsList.params[i]);
    }

    await updateSmsPanel(formData);
  };

  useEffect(() => {
    if (options) {
      setListOptions(options);
    }
  }, [options]);

  if (!options) {
    return <Typography weight="bold">دیتایی وجود ندارد!</Typography>;
  }

  return (
    <Container>
      <Wrapper>
        {listOptions?.map((option, index) => {
          return (
            <div className="my-2" key={index}>
              <Typography size="14px" weight="bold">
                {`${option.title}`}{" "}
                <span style={{ color: "red", fontSize: "12px" }}>{`${
                  option.desc ? `(${option.desc})` : ""
                }`}</span>
              </Typography>
              <div className="row">
                <div className="col-4">
                  <InputField1
                    type="text"
                    defaultValue={option.pattern}
                    label="الگو"
                  />
                </div>
                <div className="col-4">
                  <InputField1
                    type="text"
                    label="ورودی ها"
                    onKeyPress={(event) =>
                      convertOptions(event, event.target.value, option.meta)
                    }
                  />

                  <div className="d-flex mt-2">
                    {option.params?.map((param, index) => (
                      <WrapperParam key={index}>
                        <Typography primary="#fff">{param} </Typography>
                        <span
                          style={{ cursor: "pointer", margin: "0 .2rem" }}
                          onClick={() => handleDelete(option.meta, param)}
                        >
                          <FiDelete />
                        </span>
                      </WrapperParam>
                    ))}
                  </div>
                </div>
                <div className="col-4 mt-4">
                  <Button
                    bgColor="#009CF4"
                    color="#fff"
                    size="14px"
                    small="100px"
                    onclick={() => handleUpdate(option.meta)}
                  >
                    {loadingUpdateSms && select === option.meta ? (
                      <Spinner
                        animation="border"
                        color="light"
                        variant="light"
                      />
                    ) : (
                      " ویرایش"
                    )}
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </Wrapper>
    </Container>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.backgroundSidebar};
  box-shadow: ${({ theme }) => theme.shadow};
  padding: 1rem 1rem 3rem 1rem;
  border-radius: 10px;
`;

const WrapperParam = styled.div`
  display: flex;
  align-items: center;
  padding: 0.2rem;
  background-color: #009cf4;
  color: #fff;
  font-size: 13px;
  border-radius: 5px;
  margin: 0.3rem;
`;

export default InputComponentManagement;
